import { UserRole } from '../constants/UserRole';
import { BI_ERRORS, errorLogger } from '../services/loggers/errorLogger';
import { contains, join, nth, pipe, prop, replace, split } from 'ramda';

export interface ISiteInfo {
  metaSiteId: string;
  userId: string;
  roles: UserRole[];
}

export const parseSiteMediaToken = (token: string): ISiteInfo => {
  let parsed;
  try {
    parsed = simpleParseJwt(token);
  } catch (ex) {
    errorLogger.log(BI_ERRORS.settings.siteMediaTokenParse, { reason: ex });
    throw ex;
  }

  const { metasiteId: metaSiteId, userId, roles } = parsed;

  return {
    metaSiteId,
    userId,
    roles,
  };
};

interface IJWTInfo {
  userId: string;
  metasiteId: string;
  roles: string[];
}

export const simpleParseJwt: (token: string) => IJWTInfo = pipe(
  split('.'),
  nth(2),
  window.atob,
  JSON.parse,
  prop('data'),
  JSON.parse,
);

export const simpleEncodeJwt: (data: ISiteInfo) => string = pipe(
  ({ metaSiteId, userId, roles }) => JSON.stringify({ metasiteId: metaSiteId, userId, roles }),
  (data) => JSON.stringify({ data }),
  window.btoa,
  (token) => ['JWT', 'dummy-signature', token],
  join('.'),
);

export const removeTemplatePart = replace('_template_', '');

export const isNonSavedSite = contains<string>('_template_');
